import axios from "axios";
import conf from "../config";
var TIMEOUT_IN_MS = 5 * 60 * 1000;
function axiosClientFactory() {
    var apapiUrl = conf.getAuthConfig().apapiUrl;
    var axiosClient = axios.create({
        timeout: TIMEOUT_IN_MS,
        baseURL: apapiUrl,
    });
    return axiosClient;
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isAxiosError(error) {
    if (error === null) {
        return false;
    }
    return axios.isAxiosError(error);
}
export var defaultAxiosClient = axiosClientFactory();
export default defaultAxiosClient;
